import React from 'react';
import assinatura from '../../assets/images/Assinatura Decatron.png';
const Assets = () => {
    return (
        <div>
            {' '}
            <img src={assinatura} alt="Assinatura de email" />
        </div>
    );
};

export default Assets;
